import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { LeadExportDialog } from '../components/leads/LeadExportDialog';
import { ErrorBoundary } from '../components/common/ErrorBoundary';

export const LeadExportPage: React.FC = () => {
  const navigate = useNavigate();
  const [showExportDialog, setShowExportDialog] = useState(true);

  const handleClose = () => {
    console.log('Export dialog closed');
    setShowExportDialog(false);
    // Delay navigation to allow dialog to close gracefully
    setTimeout(() => {
      navigate('/leads');
    }, 100);
  };

  const handleBackClick = () => {
    setShowExportDialog(false);
    navigate('/leads');
  };

  return (
    <Box>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBackClick}
            sx={{ mr: 2 }}
          >
            Back to Leads
          </Button>
          <Typography variant="h5">
            Export Leads
          </Typography>
        </Box>

        <Typography variant="body1" color="text.secondary">
          Export your leads data in CSV or JSON format for external use, backup, or analysis.
        </Typography>
      </Paper>

      {showExportDialog && (
        <ErrorBoundary>
          <LeadExportDialog
            open={showExportDialog}
            onClose={handleClose}
          />
        </ErrorBoundary>
      )}
    </Box>
  );
};
